(function () {
  function getCurrentPageNumber() {
    const params = new URLSearchParams(window.location.search);
    const page = Number(params.get('page') || '1');

    if (!Number.isFinite(page) || page < 1) {
      return 1;
    }

    return page;
  }

  function updateCollectionPageState() {
    const path = window.location.pathname.toLowerCase();
    const isCollectionPage = path.startsWith('/collections');
    const pageNumber = getCurrentPageNumber();
    const isAfterFirstPage = isCollectionPage && pageNumber > 1;

    document.documentElement.classList.toggle('ls-is-collection-page', isCollectionPage);
    document.documentElement.classList.toggle('ls-collection-page-after-first', isAfterFirstPage);

    if (document.body) {
      document.body.classList.toggle('ls-is-collection-page', isCollectionPage);
      document.body.classList.toggle('ls-collection-page-after-first', isAfterFirstPage);
    }
  }

  updateCollectionPageState();

  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;

  history.pushState = function () {
    originalPushState.apply(history, arguments);
    setTimeout(updateCollectionPageState, 20);
    setTimeout(updateCollectionPageState, 250);
  };

  history.replaceState = function () {
    originalReplaceState.apply(history, arguments);
    setTimeout(updateCollectionPageState, 20);
    setTimeout(updateCollectionPageState, 250);
  };

  window.addEventListener('popstate', function () {
    setTimeout(updateCollectionPageState, 20);
    setTimeout(updateCollectionPageState, 250);
  });

  window.addEventListener('hashchange', function () {
    setTimeout(updateCollectionPageState, 20);
    setTimeout(updateCollectionPageState, 250);
  });

  document.addEventListener('DOMContentLoaded', updateCollectionPageState);
  window.addEventListener('load', updateCollectionPageState);

  setTimeout(updateCollectionPageState, 100);
  setTimeout(updateCollectionPageState, 500);
  setTimeout(updateCollectionPageState, 1500);
})();